export default function HeaderText(params) {
  if (!params.displayName) return null;
  const headerTextCell = document.createElement('div');
  headerTextCell.classList.add('w5-header-text-cell');
  if (params.hideTitle) return headerTextCell;
  if (params.upperCase) headerTextCell.classList.add('w5-header-text-cell--uppercase');
  let text = params.displayName;
  if (params.isPercentage) text = `${text} (%)`;
  if (params.isMandatory) text = `${text} *`;
  headerTextCell.innerHTML = text;
  return headerTextCell;
}